/* eslint-disable */

export default function () {
  ;(function () {
    const s = document.createElement('script')
    const e = !document.body ? document.querySelector('head') : document.body
    s.src = 'https://acsbapp.com/apps/app/dist/js/app.js'
    s.async = true
    s.onload = function () {
      acsbJS.init({
        statementLink: '',
        footerHtml: 'Powered by Grey Sky Media',
        hideMobile: false,
        hideTrigger: false,
        language: 'en',
        position: 'left',
        leadColor: '#3d485b',
        triggerColor: '#3b485a',
        triggerRadius: '50%',
        triggerPositionX: 'left',
        triggerPositionY: 'bottom',
        triggerIcon: 'people',
        triggerSize: 'medium',
        triggerOffsetX: 20,
        triggerOffsetY: 20,
        mobile: {
          triggerSize: 'small',
          triggerPositionX: 'left',
          triggerPositionY: 'bottom',
          triggerOffsetX: 10,
          triggerOffsetY: 0,
          triggerRadius: '50%',
        },
      })
    }
    e.appendChild(s)
  })()
}
